import React, {FunctionComponent} from 'react';
import Button, {ButtonClass} from '@treez-ui/core/buttons/Button';
import {FilterIcon} from '@treez-ui/core/icons';
import {TreezColor, treezColorMap} from '~/styles/constants';

interface Props {
    filtersApplied: boolean;
    advancedFiltersOpen: boolean;
    toggleFilterMenuOpen: () => void;
}

const {GREY_DARK, WHITE} = TreezColor;

const darkGrey = treezColorMap[GREY_DARK];
const white = treezColorMap[WHITE];

export const FiltersButton: FunctionComponent<Props> = (props: Props) => {
    const {filtersApplied, advancedFiltersOpen, toggleFilterMenuOpen} = props;

    const renderFilterButton = () => {
        if (advancedFiltersOpen) {
            return (
                <Button
                    buttonClass={ButtonClass.BASIC}
                    icon={<FilterIcon color={white} />}
                    onClick={toggleFilterMenuOpen}
                    text="Hide Filters"
                />
            );
        }
        if (filtersApplied) {
            return (
                <Button
                    buttonClass={ButtonClass.PREFERRED}
                    icon={<FilterIcon color={white} />}
                    onClick={toggleFilterMenuOpen}
                    text="Filters Applied"
                />
            );
        }
        return (
            <Button
                buttonClass={ButtonClass.QUIET}
                icon={<FilterIcon color={darkGrey} />}
                onClick={toggleFilterMenuOpen}
                text="Advanced Filters"
            />
        );
    };

    return <div className="standard-button-container">{renderFilterButton()}</div>;
};

export default FiltersButton;
